<template>
  <el-dialog
    :title="title"
    modal
    :visible.sync="dialogDisible"
    width="600px"
    :close-on-click-modal="false"
  >
    <el-form ref="formRef" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="考号" prop="memberCode">
        <el-input
          v-model.trim="form.memberCode"
          placeholder="请输入考号"
        ></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input
          v-model.trim="form.name"
          placeholder="请输入考生姓名"
        ></el-input
      ></el-form-item>
      <el-form-item label="身份证号" prop="idCard">
        <el-input
          v-model="form.idCard"
          placeholder="请输入考生身份证号"
        ></el-input
      ></el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input
          v-model.trim="form.phone"
          placeholder="请输入考生手机号"
        ></el-input
      ></el-form-item>

      <el-form-item label="等级" prop="courseLevel">
        <el-select
          v-model="form.courseLevel"
          placeholder="请选择等级"
          style="width: 100%;"
        >
          <el-option
            v-for="item in examLevel"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择考试" prop="examinationId">
        <el-select v-model.trim="form.examinationId" placeholder="请选择考试">
          <el-option
            v-for="item in examOptions"
            :key="item.examinationId"
            :label="item.name"
            :value="item.examinationId"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="sumbit()" :loading="loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { dataAdd, dataUpdate } from "../../api/student";
import { getExamsValid } from "../../api/system";
import { validateIdCard, validatePhone } from "@/utils/validate";
import { examLevel } from "@/utils/dict.js";
export default {
  data() {
    return {
      examLevel,
      dialogDisible: false,
      form: {},
      loading: false,
      examOptions: [],
      title: "",
      type: "",
      rules: {
        memberCode: [
          { required: true, message: "请输入考号", trigger: "blur" }
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        idCard: [
          { required: true, validator: validateIdCard, trigger: "blur" },
          { required: true, message: "请输入身份证号", trigger: "blur" }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: "blur" },
          { required: true, message: "请输入手机号", trigger: "blur" }
        ],
        examinationId: [
          { required: true, message: "请选择考试", trigger: "blur" }
        ],
        courseLevel: [
          { required: true, message: "请选择等级", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    // 考试选项
    async examOptionsGet() {
      const res = await getExamsValid({ pageNum: 1, pageSize: 1000 });
      this.examOptions = res.data.data;
    },
    open(type, row) {
      this.examOptionsGet();
      this.title = type == "add" ? "新增" : "编辑";
      this.type = type;
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogDisible = true;
    },
    sumbit() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          this.loading = true;
          const data = JSON.parse(JSON.stringify(this.form));
          data.examinationName = this.examOptions.find(
            item => item.examinationId === data.examinationId
          ).name;
          data.examinationCode = this.examOptions.find(
            item => item.examinationId === data.examinationId
          ).examinationCode;
          try {
            if (this.type == "add") {
              await dataAdd(data);
            } else {
              await dataUpdate(data);
            }
          } catch (e) {}
          this.$emit("success");
          this.closeDialog();
        } else {
          this.loading = false;
          return false;
        }
      });
    },
    closeDialog() {
      this.$refs.formRef.clearValidate();
      this.loading = false;
      this.dialogDisible = false;
    }
  }
};
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/views/StudentsManage/StudentDialog.vue